/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsFamilySettingsAdmin} from '../api'

 export const useQueryGetSavingsFamilySettingsAdmin = createReactQueryHook('getSavingsFamilySettingsAdmin', getSavingsFamilySettingsAdmin)
